import React from 'react'
import { SVGIconProps } from '../types'
const SvgSpeedSlow = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        d="M8 2.4a7.3 7.3 0 0 1 7.3 7.3q0 2.351-.776 3.494a1 1 0 0 1-.827.438H2.33a1 1 0 0 1-.839-.457Q.7 11.953.7 9.7A7.3 7.3 0 0 1 8 2.4m-.107 7.008c-.827.043-5.43 1.49-5.414 1.786.015.295 4.744 1.253 5.57 1.21a1.5 1.5 0 1 0-.156-2.996m4.957.992a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-9.1-4.1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m8.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M8 4a.75.75 0 1 0 0 1.5A.75.75 0 0 0 8 4"
      />
    </g>
  </svg>
)
export default SvgSpeedSlow
